<nav class="navbar navbar-expand-sm menu-bar justify-content-between">
  <ul class="navbar-nav">
    <li class="nav-item" *ngIf="role.dpa_button_newcontact">
      <a class="nav-link action-menu" (click)="newContact($event)">New Contact</a>
    </li>
    <li class="nav-item" *ngIf="role.dpa_button_delete">
      <a class="nav-link action-menu" (click)="delete($event)">Delete</a>
    </li>
    <li class="nav-item" *ngIf="role.dpa_button_merge">
      <a class="nav-link action-menu" (click)="merge($event)">Merge</a>
    </li>
    <li class="nav-item" *ngIf="role.dpa_button_sms">
      <a class="nav-link action-menu" (click)="sms($event)">SMS</a>
    </li>
    <li class="nav-item" *ngIf="role.dpa_button_email">
      <a class="nav-link action-menu" (click)="email($event)">Email</a>
    </li>
  </ul>
  <form class="form-inline">
    <!-- <input class="form-control filter" type="search" placeholder="Search"> -->
  </form>

</nav>

<div class="row mt-3">
  <div class="col-12 p-0">
    <p class="mb-0">
      <button class="btn btn-primary collapsible" type="button" data-toggle="collapse" data-target="#caseCriteria"
        aria-expanded="false" aria-controls="caseCriteria">
        ค้นหา
        <i class="fa" aria-hidden="true"></i>
      </button>
    </p>
    <div class="collapse show" id="caseCriteria">
      <div class="card card-body">
        <div class="row">

          <div class="col-2 text-right">
            <label>ชื่อ:</label>
          </div>
          <div class="col-4">
            <input type="text" class="form-control" [(ngModel)]="firstnameSearch">
          </div>
          <div class="col-2 text-right">
            <label>นามสกุล:</label>
          </div>
          <div class="col-4">
            <input type="text" class="form-control" [(ngModel)]="lastnameSearch">
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>เบอร์โทร:</label>
          </div>
          <div class="col-4">
            <input type="text" class="form-control number" [(ngModel)]="telephoneSearch">
          </div>
          <div class="col-2 text-right">
            <div *ngIf="!isCrisis">
              <label>หมายเลขบัตรประชาชน/</label>
              <br>
              <label>เลขประจำตัวผู้เสียภาษี</label>
            </div>
            <div *ngIf="isCrisis">
              <label>หมายเลขบัตรประชาชน/</label>
              <br>
              <label>เลขประจำตัวผู้เสียภาษี/</label>
              <br>
              <label>หมายเลขพาสปอร์ต</label>
            </div>
          </div>
          <div class="col-4">
            <input type="text" class="{{isCrisis ? 'form-control' :  'form-control number'}}" [(ngModel)]="idcardSearch">
          </div>

        </div>

        <div class="row mt-3" *ngIf="isCrisis">
          <div class="col-2 text-right">
            <label>เลขที่บัญชี:</label>
          </div>
          <div class="col-4">
            <input type="text" class="form-control number" [(ngModel)]="accountNoSearch">
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12 text-center">
            <button class="btn btn-primary m-2" (click)="search()">
              ค้นหา
              <span class="fa fa-search"></span>
            </button>
            <button class="btn btn-default m-2" (click)="resetSearchCirteria()">
              ล้างค่า
              <span class="fa fa-times"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="card card-default mt-3">
  <div class="card-header">
    <h3 class="card-title font-cust-blue">Contact List</h3>
  </div>
  <!-- /.card-header -->
  <div class="card-body table-responsive">
    <table #tbCon id="tbContact" style="width:100%" class="table table-bordered table-hover result-table">
      <thead>
        <tr>
          <th class="checkbox-col">
            <input type="checkbox" [(ngModel)]="isCheckedAll" (change)="onCheckAllChange()">
          </th>
          <th>ผู้ติดต่อ</th>
          <th>หมายเลขโทรศัพท์</th>
          <th>Email</th>
          <th>ผู้สร้างข้อมูล</th>
          <th>Create on</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of contactList; let i = index">
          <td align="center" class="checkbox-col">
            <input type="checkbox" class="row-checker" value="{{c.contactid}}" name="{{c.emailaddress1}}">
          </td>
          <td class="col-fullname">{{(c.firstname || '')  + ' ' + (c.lastname || '')}}</td>
          <td class="col-tel">{{c.telephone1}}</td>
          <td class="">{{c.emailaddress1}}</td>
          <td>{{c.dpa_createdbyname}}</td>
          <td>{{ c.createdon | thaidate:'short' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Modal Delete-->
<div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="deleteModalLabel">ยืนยันลบ</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <label>คุณยืนยันที่จะลบ contact หรือไม่</label>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-info mr-2" (click)="confirmDelete()">ลบ</button>
            <button type="button" class="btn btn-info ml-2" (click)="CloseModal('deleteModal')">ยกเลิก</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Merge-->
<div class="modal fade" id="mergeModal" tabindex="-1" role="dialog" aria-labelledby="mergeModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="mergeModalLabel">Merge</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5 offset-md-1">
            <b>
              <label>
                <input type="radio" name="mainContact" (change)="mainChange(1)" checked>
                {{contact1.firstname + " " + contact1.lastname}}
              </label></b>
          </div>
          <div class="col-5 offset-md-1">
            <b>
              <label>
                <input type="radio" name="mainContact" (change)="mainChange(2)">
                {{contact2.firstname + " " + contact2.lastname}}
              </label></b>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-1">
            <div class="row text-right">
              <label class="col-12 mt-3 mb-3"><input type="radio" name="name" [value]="1" [(ngModel)]="chkName"></label>
              <label class="col-12 mt-3 mb-3"><input type="radio" name="lastname" [value]="1"
                  [(ngModel)]="chkLastname"></label>
              <label class="col-12 mt-3 mb-3"><input type="radio" name="dob" [value]="1" [(ngModel)]="chkDob"></label>
              <label class="col-12 mt-3 mb-3"><input type="radio" name="idNo" [value]="1" [(ngModel)]="chkIdNo"></label>
              <label class="col-12 mt-3 mb-3"><input type="radio" name="email" [value]="1"
                  [(ngModel)]="chkEmail"></label>
              <label class="col-12 mt-3 mb-3"><input type="radio" name="tel" [value]="1" [(ngModel)]="chkTel"></label>
            </div>
          </div>
          <div class="col-5">
            <div class="row border rounded border-success pl-2">
              <label class="col-12 mt-3 mb-3">ชื่อ: {{contact1.firstname}}</label>
              <label class="col-12 mt-3 mb-3">นามสกุล: {{contact1.lastname}}</label>
              <label class="col-12 mt-3 mb-3">วัน/เดือน/ปี เกิด: {{contact1.dob | thaidate}}</label>
              <label class="col-12 mt-3 mb-3">เลขบัตรประชาชน: {{contact1.dpa_idcard}}</label>
              <label class="col-12 mt-3 mb-3">อีเมล: {{contact1.emailaddress1}}</label>
              <label class="col-12 mt-3 mb-3">เบอร์โทรศัพท์: {{contact1.telephone1}}</label>
            </div>
          </div>
          <div class="col-1">
            <div class="row text-right">
              <label class="col-12 mt-3 mb-3"><input type="radio" name="name" [value]="2" [(ngModel)]="chkName"></label>
              <label class="col-12 mt-3 mb-3"><input type="radio" name="lastname" [value]="2"
                  [(ngModel)]="chkLastname"></label>
              <label class="col-12 mt-3 mb-3"><input type="radio" name="dob" [value]="2" [(ngModel)]="chkDob"></label>
              <label class="col-12 mt-3 mb-3"><input type="radio" name="idNo" [value]="2" [(ngModel)]="chkIdNo"></label>
              <label class="col-12 mt-3 mb-3"><input type="radio" name="email" [value]="2"
                  [(ngModel)]="chkEmail"></label>
              <label class="col-12 mt-3 mb-3"><input type="radio" name="tel" [value]="2" [(ngModel)]="chkTel"></label>
            </div>
          </div>
          <div class="col-5">
            <div class="row border rounded border-primary pl-2">
              <label class="col-12 mt-3 mb-3">ชื่อ: {{contact2.firstname}}</label>
              <label class="col-12 mt-3 mb-3">นามสกุล: {{contact2.lastname}}</label>
              <label class="col-12 mt-3 mb-3">วัน/เดือน/ปี เกิด: {{contact2.dob | thaidate}}</label>
              <label class="col-12 mt-3 mb-3">เลขบัตรประชาชน: {{contact2.dpa_idcard}}</label>
              <label class="col-12 mt-3 mb-3">อีเมล: {{contact2.emailaddress1}}</label>
              <label class="col-12 mt-3 mb-3">เบอร์โทรศัพท์: {{contact2.telephone1}}</label>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-info mr-2" (click)="beforeConfirmMerge()">Merge</button>
            <button type="button" class="btn btn-info ml-2" (click)="CloseModal('mergeModal')">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal confirm Merge-->
<div class="modal fade" id="mergeConfirmModal" tabindex="-1" role="dialog" aria-labelledby="mergeModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="mergeModalLabel2">Confirm Merge</h5>
      </div>
      <div class="row mt-3">
        <div class="col-2 text-right">
          <!-- <label>คำนำหน้า</label> -->
          <label>ชื่อ</label>
        </div>
        <div class="col-3">
          <!-- <input type="text" class="form-control" value="" readonly> -->
          <input type="text" class="form-control" value="{{confirmMergeList.firstname}}" readonly>
        </div>
        <div class="col-2 text-right">
          <label>นามสกุล</label>
        </div>
        <div class="col-3">
          <input type="text" class="form-control" value="{{confirmMergeList.lastname}}" readonly>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-2 text-right">
          <!-- <label>คำนำหน้า</label> -->
          <label>วัน/เดือน/ปี เกิด</label>
        </div>
        <div class="col-3">
          <!-- <input type="text" class="form-control" value="" readonly> -->
          <input type="text" class="form-control" value="{{confirmMergeList.birthdate | thaidate}}" readonly>
        </div>
        <div class="col-2 text-right">
          <label>เลขบัตรประชาชน</label>
        </div>
        <div class="col-3">
          <input type="text" class="form-control" value="{{confirmMergeList.dpa_idcard}}" readonly>
        </div>
      </div>
      
      <div class="row mt-3">
        <div class="col-2 text-right">
          <!-- <label>คำนำหน้า</label> -->
          <label>อีเมล</label>
        </div>
        <div class="col-3">
          <!-- <input type="text" class="form-control" value="" readonly> -->
          <input type="text" class="form-control" value="{{confirmMergeList.emailaddress1}}" readonly>
        </div>
        <div class="col-2 text-right">
          <label>เบอร์โทรศัพท์</label>
        </div>
        <div class="col-3">
          <input type="text" class="form-control" value="{{confirmMergeList.telephone1}}" readonly>
        </div>
      </div>

        <div class="row mt-5">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-info mr-2" (click)="confirmMerge()">Merge</button>
            <button type="button" class="btn btn-info ml-2" (click)="CloseModal('mergeConfirmModal')">Cancel</button>
          </div>
        </div>
        
        <div class="row mt-5">
          <div class="col-12 text-center"> 
          </div>
        </div>
      </div>
    </div>
  </div> 

<!-- Modal SMS-->
<div class="modal fade" id="smsModal" tabindex="-1" role="dialog" aria-labelledby="smsModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="smsModalLabel">Select SMS template</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5 text-right">
            <label class="required">เลือก SMS Template</label>
          </div>
          <div class="col-7">
            <select class="form-control" (change)="smsChange()" [(ngModel)]="selectedSms">
              <option value="">เลือก</option>
              <option *ngFor="let s of smsTemplate" [value]="s.dpa_externalsmstemplateid">
                {{s.dpa_name}}
              </option>
            </select><span class="text-danger" *ngIf="submittedSms && (selectedSms == null || selectedSms == '')">
              กรุณาระบุ SMS Template
            </span>
          </div>

          <div class="col-12 mt-3 ">
            <div [innerHTML]="smsText" class="border border-secondary p-3 overflow-auto"></div>
          </div>

          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-info mr-2" (click)="confirmSMS()">OK</button>
            <button type="button" class="btn btn-info ml-2" (click)="CloseModal('smsModal')">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Email-->
<div class="modal fade" id="emailModal" tabindex="-1" role="dialog" aria-labelledby="emailModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="emailModalLabel">Select Email template</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-3 text-right">
            <label class="required">เลือก Email Template</label>
          </div>
          <div class="col-9">
            <select class="form-control" (change)="emailChange()" [(ngModel)]="selectedEmail">
              <option value="">เลือก</option>
              <option *ngFor="let e of emailTemplate" [value]="e.templateid">
                {{e.title}}
              </option>
            </select>
            <span class="text-danger" *ngIf="submittedEmail && (selectedEmail == null || selectedEmail == '')">
              กรุณาระบุ Email Template
            </span>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-3 text-right">
            <label class="">ไฟล์แนบ</label>
          </div>
          <div class="col-9">
            <div [innerHTML]="attachments" class="border border-secondary p-3 overflow-auto"></div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <div class="border border-secondary p-3 overflow-auto">
              <div id="summernote"></div>
            </div>
          </div>

          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-info mr-2" (click)="confirmEmail()">OK</button>
            <button type="button" class="btn btn-info ml-2" (click)="CloseModal('emailModal')">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.html